import { ref, watch } from "vue"

export function useViewMode(storageKey, defaultMode = "list") {
  const viewMode = ref(defaultMode)

  function loadSavedView() {
    try {
      const saved = localStorage.getItem(storageKey)
      if (saved === "list" || saved === "cards") {
        viewMode.value = saved
      }
    } catch {
      // localStorage might be unavailable
    }
  }

  function setViewMode(mode) {
    viewMode.value = mode
    try {
      localStorage.setItem(storageKey, mode)
    } catch {
      // localStorage might be unavailable
    }
  }

  loadSavedView()

  return { viewMode, setViewMode, loadSavedView }
}
